import React from "react";
import { Container, Grid, Paper, Typography, useTheme } from "@mui/material";
import CustomButton from "../../shared/CustomButton";
import { useTranslation } from "react-i18next";
import useNavigation from "../../../hooks/useNavigation";
const ServiceCard = ({ title, description, isLast }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        p: "28px",
        height: isLast
          ? { xs: "auto", md: "180px" }
          : { xs: "350px", md: "230px" },
        border: "1px solid #D6D8DB",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        lineHeight: "24px",
        gap: "24px",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.02)",
          border: "2px solid #bdbfc1",
        },
      }}
    >
      <Typography
        sx={{
          fontSize: "24px",
          fontWeight: "700",
          color: theme.palette.primary.title,
          lineHeight: "24px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "500",
          color: theme.palette.primary.body,
          lineHeight: "24px",
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
};

const ServicesSection = ({ data = [] }) => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const { navigateTo } = useNavigation();
  const locale = i18n.language || localStorage.getItem("language") || "en";
  const handleContactUS = () => {
    navigateTo(`/${locale}/contact`);
  };
  return (
    <Container sx={{ py: 5, overflow: "hidden" }}>
      <Grid container spacing={3}>
        {data?.map((service, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={index === data.length - 1 ? 12 : 6}
            key={index}
          >
            <ServiceCard
              title={service.title[currentLang]}
              description={service.description[currentLang]}
              isLast={index === data.length - 1}
            />
          </Grid>
        ))}
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", mt: 3 }}
        >
          <CustomButton
            backgroundImage="linear-gradient(90deg, #0A1F52 0%, #1646B8 100%)"
            onClick={handleContactUS}
          >
            {t("buttons.Get a Consultation")}
          </CustomButton>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ServicesSection;
